<template>
  <div class="modal fade" id="vehicleModal" tabindex="-1" aria-labelledby="vehicleModal" aria-hidden="true" data-bs-backdrop="static" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="vehicleModalLabel">Авто</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <template v-if="valid && info[0]">
            <div v-if="residentRulesError || !validFields || !validRegistration" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
              <div class="d-flex flex-column text-light pe-0 pe-sm-10">
                <span v-if="residentRulesError">{{ residentRulesError }}</span>
                <span v-else-if="!validRegistration">По данному ТС нет регистрации. Уточните данные в центре регистрации авто.</span>
                <span v-else-if="!validFields">Пожалуйста, заполните все обязательные поля, чтобы продолжить.</span>
              </div>
            </div>
            <vehicle-card
              v-for="(item, key) in this.info"
              @click="selectedClient = key"
              :class="(key == selectedClient ? (!validFields || residentRulesError || !validRegistration ? 'border-danger' : 'border-success') : '')"
              :vehicle="item"
              :key="key"
            >
              <template v-if="!residentRulesError && validRegistration" v-slot:change>
                <span class="edit-item" @click="isEdited(true)">
                  <i class="ki-outline ki-notepad-edit"></i>
                </span>
              </template>
            </vehicle-card>
            <button v-if="!isEdit" class="btn btn-light-danger btn-sm w-100" @click="clearForm">Очистить</button>
          </template>
          <template v-else>
            <vehicle-search :module="this.module" @createVehicle="createVehicle" :is-clear="clear" :car-added-list="this.carAddedList" :product-type="productType" v-if="search.step === 0"/>
            <template v-if="search.step >= 1">
              <vehicle-from :module="this.module" @cancel="cancel()" @set-vehicle="setVehicle" :search-data="search.data" :product-type="productType" :is-clear="clear" :vehicle-data="info[selectedClient] ? [clone(info[selectedClient])] : null" :is-edit="isEdit"/>
            </template>
          </template>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              @click="clearForm"
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
          <button
              v-if="valid"
              @click="addVehicle"
              v-on:keyup.enter="addVehicle"
              :disabled="!validFields || residentRulesError || !validRegistration"
              type="button"
              class="btn btn-sm btn-primary"
              v-html="!isEdit ? 'Добавить' : 'Сохранить'"
          ></button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleSearch        from '@/components/Form/Uidb/Search/VehicleSearch.vue';
import VehicleFrom          from '@/components/Form/Uidb/Item/Vehicle.vue';
import VehicleCard          from '@/components/Form/Uidb/Card/VehicleCard.vue';
import LoaderFull           from '@/components/Main/LoaderFull.vue';
import axios                from "axios";

export default {
  name: 'VehicleModal',
  components: { LoaderFull, VehicleCard, VehicleSearch, VehicleFrom },
  emits: ['addVehicle', 'clearVehicle'],
  props: {
    vehicleAddedList: {
      type: Array,
      default: () => []
    },
    carAddedList: {
      type: Array,
      default: () => []
    },
    productType: {
      type: Number,
      default: 0
    },
    module: {
      type: Function,
      required: true
    },
    vehicle: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      search: {
        data: null,
        step: 0
      },
      selectedClient: 0,
      isEdit:         false,
      clear:          false,
      valid:          false,
      info:           {},
      infoTmp:        {},
      loader:         false,
      validFields:    true,
      validRegistration: true,
      residentRulesError: false
    }
  },
  methods: {
    clearForm() {
      this.selectedClient = 0
      this.search         = {data:null,step:0}
      this.isEdit         = false
      this.clear          = true
      this.valid          = false
      this.info           = {}
      if (this.clear) {
        this.$emit('clearVehicle', this.clear)
        this.clear = false
      }
    },
    clone(val) {
      return structuredClone(val)
    },
    changeData(val) {
      if (val.data) {
        this.info[`${val.name}`] = val.data
        this.validFields = this.module.Validator.vehicleByRequiredFields([this.info[this.selectedClient]], this.productType === 1 ? 0 : 1 )
        if (this.info[this.selectedClient]) this.residentRulesError = this.module.Validator.checkResidentRulesSingle(this.info[this.selectedClient].verify, this.productType, 3)
        this.validRegistration = this.module.Validator.validateVehicleRegistration(this.info[this.selectedClient])
      } else {
        delete this.info[`${val.name}`]
      }
    },
    cancel() {
      this.valid = true;
      this.info = structuredClone(this.infoTmp)
    },
    isEdited(val) {
      this.isEdit = val
      this.valid  = !val
    },
    changeFilterStep (val) {
      this.filterStep = val
    },
    createVehicle(val) {
      this.search.step = val.step
      for (let key in val.data) {
        switch (this.productType) {
          case 1:
            break;
          case 2:
            val.data[key].registration.region_id = 17
            break;
          case 3:
            val.data[key].registration.region_id = 18
            break;
          default: break
        }
      }
      if (val.step === 2) {
        this.search.data = val.data
      } else {
        this.info     = val.data
        this.infoTmp  = structuredClone(val.data);
        this.valid    = val.data.length > 1 ? true : this.module.Validator.vehicleByRequiredFields([this.info[this.selectedClient]], this.productType === 1 ? 0 : 1 )
      }
    },
    addVehicle() {
      if (!this.validFields || this.residentRulesError || !this.validRegistration) return
      const vehicle = this.info[this.selectedClient]
      if (vehicle.verify && !!vehicle.verified_at) {
        this.$emit('addVehicle', vehicle)
        setTimeout(() => { this.clearForm() }, 100)
        this.modalHidden()
      } else {
        this.loader = true
        let data = null
        if (this.isEdit && this.search.hasOwnProperty('edited')) {
          data = {
            key:this.search.edited.key,
            data:this.info[this.selectedClient]
          }
        } else {
          data = this.info[this.selectedClient]
        }
        this.setVehicleSimple()
            .then(res => {
              if (res.data.result) {
                this.$emit('addVehicle', data)
                setTimeout(() => { this.clearForm() }, 100)
                this.modalHidden()
              } else {
                this.$notifyError(res.data)
              }})
            .catch(err => {
              this.$notifyError(err)
            })
            .finally(() => this.loader = false)
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('vehicleModal');
      const modal = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    setVehicle(vehicle = null) {
      this.loader = true
      let headers = [vehicle ? vehicle :this.info[this.selectedClient]]
      axios.post('/api/vehicle/set', headers)
          .then(res => {
            let text;
            if (res.status === 200 && res.data.number) {
              text = 'Данные по '+res.data.number + ' обновлено успешно'
              this.$notifySuccess({message: text, title: 'Обновлено'})
              this.info[this.selectedClient] = res.data
              this.valid = true
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loader = false
          })
    },
    async setVehicleSimple() {
      let headers = [this.info[this.selectedClient]]
      return await axios.post('/api/vehicle/set-simple', headers)
    },
  },
  watch: {
    info: {
      deep: true,
      handler(val) {
        if (!this.isEdit) {
          if (Array.isArray(val)) {
            this.valid = val.length > 1 ? true : !!val[0].id
          } else {
            this.valid = this.module.Validator.vehicleByInfoAndSearchStep(this.search.step, val)
          }
        }
        this.validFields = this.module.Validator.vehicleByRequiredFields([val[this.selectedClient] ?? {}], this.productType === 1 ? 0 : 1);
        if (this.info[this.selectedClient]) this.residentRulesError = this.module.Validator.checkResidentRulesSingle(this.info[this.selectedClient].verify, this.productType, 3)
        this.infoTmp = structuredClone(val);
        this.validRegistration = this.module.Validator.validateVehicleRegistration(this.info[this.selectedClient])
      }
    },
    vehicle: {
      immediate: true,
      handler(val) {
        if (this.info) {
          this.validFields = this.module.Validator.vehicleByRequiredFields([this.info[this.selectedClient] ?? {}], this.productType === 1 ? 0 : 1);
          if (this.info[this.selectedClient]) this.residentRulesError = this.module.Validator.checkResidentRulesSingle(this.info[this.selectedClient].verify, this.productType, 3)
          this.validRegistration = this.module.Validator.validateVehicleRegistration(this.info[this.selectedClient])
        }
        this.infoTmp = structuredClone(this.info);
        if (val) {
          if (!val.new) {
            this.info        = {0:val.data}
            this.valid       = !!this.info[0].id
            this.isEdit      = true
            this.search.step = 3
            this.search['edited'] = {key:val.key}
          } else {
            this.clearForm()
          }
        }
      }
    },
    selectedClient: {
      immediate: true,
      handler(val) {
        if (this.info[val]) {
          this.validFields = this.module.Validator.vehicleByRequiredFields([this.info[val]],this.productType === 1 ? 0 : 1)
          if (this.info[this.selectedClient]) this.residentRulesError = this.module.Validator.checkResidentRulesSingle(this.info[this.selectedClient].verify, this.productType, 3)
          this.validRegistration = this.module.Validator.validateVehicleRegistration(this.info[this.selectedClient])
        }
      }
    }
  }
}
</script>

<style scoped>

</style>